import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { WoDetailInstructionsModule } from '../wo-detail-instructions/wo-detail-instructions.module';

import { JobsiteContactComponent } from './jobsite-contact.component';

@NgModule({
    declarations: [
        JobsiteContactComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        WoDetailInstructionsModule
    ],
    exports: [
        JobsiteContactComponent
    ]
})

export class JobsiteContactModule { }
